import $ from 'jquery'
import util from './util.js'
import {report} from '../common/luna_track/clickReport.js'
import {
    renderHotWord
} from './initSearchHotWord.js'

const popupBox = function (sureFun, cancelFun) {
    var popupBox = $(`<div class="locationBgLayer clearHistoryPopup">
        <div class="popupBox">
            <p>确定删除全部浏览记录？</p>
            <button class="cancelBtn">取消</button>
            <button class="sureBtn">确认</button>
        </div>
    </div>`)

    $('body').append(popupBox)

    $('.locationBgLayer').on('touchmove', function (event) {
        event.preventDefault()
    })

    $('.popupBox').on('click', '.sureBtn', function () {
        popupBox.hide().remove()
        typeof sureFun === 'function' && sureFun()
    })

    $('.popupBox').on('click', '.closeBtn, .cancelBtn', function () {
        popupBox.hide().remove()
        typeof cancelFun === 'function' && cancelFun()
    })
}

/**
 * [getURLParameter 获取当前URL参数]
 * @param  {[string]} name [要获取的键名key]
 * @return {[string]}      [对应键值value]
 */
const getURLParameter = function (name) {
    return (
        decodeURIComponent(
            (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
                location.search
            ) || [, ''])[1].replace(/\+/g, '%20')
        ) || null
    )
}

/**
 * [setSearchHistory localStorage中设置浏览历史]
 * @param {[string]} searchKeywords [要存储的用户搜索历史]
 */
const setSearchHistory = function (searchKeywords) {
    // var historyArr = [];
    let historyArr = (localStorage.searchHistory || '')
        .split(',')
        .filter(item => !!item),
        keywordsIndex = historyArr.indexOf(searchKeywords)

    if (keywordsIndex >= 0) {
        historyArr = historyArr.splice(keywordsIndex, 1).concat(historyArr)
    } else {
        historyArr.unshift(searchKeywords)
    }
    // localStorage.searchHistory = historyArr;
    localStorage.searchHistory = historyArr.join(',')

    // if (!localStorage.searchHistory) {
    //     //判断是否存在浏览历史
    //     historyArr[0] = searchKeywords;
    //     localStorage.searchHistory = historyArr.join(',');
    // } else {
    //     if (localStorage.searchHistory.indexOf(searchKeywords) == -1) {
    //         //判断是否有重复
    //         historyArr = localStorage.searchHistory.split(',');
    //         historyArr.unshift(searchKeywords);
    //         localStorage.searchHistory = historyArr.join(',');
    //     } else {
    //         if (
    //             localStorage.searchHistory.indexOf(searchKeywords) +
    //                 searchKeywords.length ==
    //             localStorage.searchHistory.length
    //         ) {
    //             //判断是否是最后一项
    //             localStorage.searchHistory =
    //                 searchKeywords +
    //                 ',' +
    //                 localStorage.searchHistory.replace(
    //                     ',' + searchKeywords,
    //                     ''
    //                 );
    //         } else {
    //             localStorage.searchHistory =
    //                 searchKeywords +
    //                 ',' +
    //                 localStorage.searchHistory.replace(
    //                     searchKeywords + ',',
    //                     ''
    //                 );
    //         }
    //     }
    // }
    // alert(localStorage.searchHistory);
}

/**
 * [getJumpLink 根据关键词获取跳转链接]
 * @param  {[string]}   searchKeywords [关键词]
 * @param  {Function} callback       [回调函数名]
 */
const getJumpLink = function (searchKeywords, callback) {
    var cityStr = util.getActiveCityName()
    var queryUrl = `/api/search?-15=20&kw=${searchKeywords}&city=${cityStr}&plat=m`
    $.ajax({
        type: 'GET',
        url: queryUrl,
        dataType: 'jsonp',
        jsonp: 'callback',
        jsonpCallback: 'callback' + callback,
        success: function (data) {
            $('.searchBox').hide()
            if (typeof window.TCB_CLICKREPORT.clickReport === 'object') {
                window.TCB_CLICKREPORT.clickReport.pageType = window.TCB_CLICKREPORT.pageType
            }
            $('.body_div').show()
            $('.searchArea').val('')
            $('.searchList').empty().hide()
            try {
                //iphone旧版本搜索中间页兼容
                setSearchHistory(searchKeywords)
            } catch (err) {
                console.log(err)
            }
            var PGTID = getGTID()
            window.location.href = data.url + '&PGTID=' + PGTID
        },
        error: function () {
            console.log('查询失败')
        }
    })
}

/**
 * [showSearchHistory 取localStorage展示浏览历史，热门搜索]
 */
const showSearchHistory = function () {
    if (localStorage.searchHistory && localStorage.searchHistory.length != 0) {
        var historyArr = localStorage.searchHistory.split(',')
        var historyDom = '<ul>'
        for (let i = 0, len = historyArr.length; i < len; i++) {
            historyDom += `<li data-index="${i}"><a class="clickreport-luna-search" href="javascript:void(0)" data-tag="lunasearch-record-2">${
                historyArr[i]
            }</a></li>`
        }
        historyDom += '</ul>'
        $('.historyList')
            .html(historyDom)
            .parent()
            .show()
            .prev()
            .show()
    } else {
        $('.hotSearch').show()
    }
}

const getSearchResultList = function (keywords = '') {
    if (keywords) {
        var [url, inputbox, cityid, catid, callback] = []
        url = '//suggest.58.com/searchsuggest_14.do'
        inputbox = keywords.replace(/\s/g, '')
        cityid = ____json4fe.locallist[0].dispid
        catid = '0'
        callback = Math.random()
            .toString()
            .substring(2, 6)
        $.ajax({
            type: 'GET',
            url: url,
            data: {
                inputbox: inputbox,
                cityid: cityid,
                catid: catid,
                num: '10',
                client: 'm'
            },
            dataType: 'jsonp',
            jsonp: 'callback',
            jsonpCallback: 'callback' + callback,
            success: function (data) {
                var [item, searchListDom, newInputbox, searchKeywords] = [
                    '',
                    '<ul>',
                    '',
                    ''
                ]
                for (let i = 0, len = data.w.length; i < len; i++) {
                    item = data.w[i]
                    if (item.k.indexOf(keywords) !== -1) {
                        newInputbox = item.k.replace(
                            keywords,
                            `<span class="keywords">${keywords}</span>`
                        )
                        searchListDom += `<li data-index="${i}" data-words="${
                            item.k
                        }"><span class="searchlistitem">${newInputbox}</span></li>`
                    } else {
                        searchListDom += `<li data-index="${i}" data-words="${
                            item.k
                        }"><span class="searchlistitem">${item.k}</span></li>`
                    }
                }
                searchListDom += '</ul>'
                $('.searchBox .searchList').html(searchListDom).show();
                $('.searchList li').on('click', function () {
                    //搜索结果列表项点击事件
                    searchKeywords = $(this).attr('data-words')
                    getJumpLink(searchKeywords, callback)
                    report({
                        action: 1003,
                        element_id: 3,
                        module_id: 'search_page',
                        element_param:{type:'suggesst',content:searchKeywords,pos:$(this).attr('data-index')}
                    })
                })
            },
            error: function () {
                $('.searchBox .searchList').empty().hide()
                console.log('查询失败')
            }
        })
    } else {
        $('.searchList').empty().hide()
        showSearchHistory()
    }
}

const initSearch = function () {
    let clearInputBtn = $(`<span class="clear-input-btn">
				<i class="iconfont">&#xe601;</i>
			</span>`).on('click', function () {
            $(this)
                .siblings('.searchArea')
                .val('')
            getSearchResultList()
        }),
        clearHistoryBtn = $(`<span class="clear-search-history" data-tag="lunasearch-record-1">
			<i class="iconfont">&#xe606;</i>
		</span>`),
        refreshBtn = $(`<span class="refresh-btn" data-tag="lunasearch-hot-1">
			<i class="iconfont">&#xe607;</i>
		</span>`)
    $('.searchBox > .searchInput > .searchTxtarea form > input').prop(
        'required',
        'required'
    )
    clearHistoryBtn.on('click', function () {
        popupBox(function () {
            localStorage.searchHistory = ''
            $('.searchHistory')
                .hide()
                .children('.historyList')
                .html('')
        })
    })
    refreshBtn.on('click', function () {
        renderHotWord()
    })
    $('.lunaSearch > .logo').attr('data-tag', 'lunadaleizp-search-1')
    $('.lunaSearch .city').attr('data-tag', 'lunadaleizp-search-2')
    $('.lunaSearch .searchTxtarea > span').attr(
        'data-tag',
        'lunadaleizp-search-3'
    )
    $('.searchBox > .searchInput .city').attr('data-tag', 'lunasearch-top-1')
    $('.searchBox > .searchInput > .searchTxtarea > span').attr(
        'data-tag',
        'lunasearch-top-2'
    )
    $('.searchBox > .searchInput .close').attr('data-tag', 'lunasearch-top-3')
    $('.searchBox > .searchInput > .searchTxtarea form').append(clearInputBtn)
    $('.searchHistory > h2').append(clearHistoryBtn)
    $('.hotSearch > h2').append(refreshBtn)
}

export default function searchEvent() {
    initSearch()

    $('.lunaSearch')
        .on('click', 'span', function () {
            if (typeof window.TCB_CLICKREPORT.clickReport === 'object') {
                window.TCB_CLICKREPORT.clickReport.pageType = 7
            }
            //搜索框点击事件
            $('.body_div').hide()
            //变成搜索页pageType
            $('.searchBox').show()
            $('.searchBox input').focus()
            showSearchHistory()
            report({
                action: 1003,
                element_id: 3,
                module_id: 'search'
            })
        })
        .on('click', '.logo', function () {
            report({
                action: 1003,
                element_id: 1,
                module_id: 'search',
            })
        })
        .on('click', '.city', function () {
            report({
                action: 1003,
                element_id: 2,
                module_id: 'search',
            })
        })
    $('.searchBox')
        .on('click', '.close', function () {
            //取消按钮点击事件
            $('.searchBox').hide()
            //切换回原有pageType
            if (typeof window.TCB_CLICKREPORT.clickReport === 'object') {
                window.TCB_CLICKREPORT.clickReport.pageType = window.TCB_CLICKREPORT.pageType
            }
            $('.body_div').show()
            $('.searchArea').val('')
            $('.searchBox .searchList').empty().hide()
            $('.searchBox input').blur()
            report({
                action: 1003,
                element_id: 15,
                module_id: 'search_page',
                element_param:{type:'close'}
            })
        })
        .on('input', '.searchArea', function () {
            //搜索中间页搜索框状态变化事件，请求匹配项
            getSearchResultList($(this).val())
        })
        .on('click', '.historyList li', function () {
            //浏览历史点击事件
            var searchKeywords = $(this).text(),
                callback = Math.random()
                .toString()
                .substring(2, 6)
            getJumpLink(searchKeywords, callback)
            report({
                action: 1003,
                element_id: 3,
                module_id: 'search_page',
                element_param:{type:'history',content:searchKeywords,pos:$(this).attr('data-index')}
            })
        })
        .on('click', '.hotList li a', function () {
            report({
                action: 1003,
                element_id: 3,
                module_id: 'search_page',
                element_param:{type:'hot',content:$(this).text(),pos:($(this).attr('data-index') || '')}
            })
        })
        .on('click', '.searchInput .city', function () {
            report({
                action: 1003,
                element_id: 2,
                module_id: 'search_page',
            })
        })
    $('.searchBox form').on('submit', function () {
        //搜索中间页搜索框回车事件
        console.log('submit')
        var callback = Math.random().toString().substring(2, 6)
        var searchKeywords = $('.searchBox .searchArea').val()
        if (searchKeywords) {
            getJumpLink(searchKeywords, callback)
        }
        report({
            action: 1003,
            element_id: 3,
            module_id: 'search_page',
            element_param:{type:'submit',content:searchKeywords}
        })
        return false
    })
}